// extracted by mini-css-extract-plugin
export default {"flightNumber":"flightNumber__1Lx2c"};